import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  Modal,
} from '@resy/ui-kitchen';
import GDAConciergeBooking from './GDAConciergeBooking';

const GDAConciergeBookingModal = ({ isMobile, closeModal, isOpen }) => {
  const [gdaConciergeIsOpen, setGdaConciergeIsOpen] = useState(isOpen);

  const getStyles = () => (
    {
      content: {
        border: 'none',
        maxWidth: isMobile ? '768px' : '700px',
        maxHeight: isMobile ? '100%' : 'none',
        inset: isMobile ? 'auto 0 0' : '20vh 40px auto',
        padding: '0',
      },
    }
  );

  const gdaConciergeBookingCloseModal = () => {
    if (closeModal) {
      closeModal();
    }
    setGdaConciergeIsOpen(false);
  };

  return (
    <Modal isOpen={gdaConciergeIsOpen} styles={getStyles()}>
      <GDAConciergeBooking closeModal={gdaConciergeBookingCloseModal} />
    </Modal>
  );
};

GDAConciergeBookingModal.propTypes = {
  isMobile: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

GDAConciergeBookingModal.defaultProps = {
  isMobile: false,
  isOpen: true,
};

export default GDAConciergeBookingModal;
